import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Invoices_ds_get_invoice_lines_grouped_by_invoiceIdService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { invoiceIds: number[] }): 
  Promise<{ result: { LineTotal?: number, InvoiceId?: number }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.invoiceIds)) {
      missingRequiredInParams.push('\'invoiceIds\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Invoices/datasources/ds_get_invoice_lines_grouped_by_invoiceId/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { invoiceIds: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { LineTotal?: number, InvoiceId?: number }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.invoiceIds)) {
      missingRequiredInParams.push('\'invoiceIds\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Invoices/datasources/ds_get_invoice_lines_grouped_by_invoiceId/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { invoiceIds: number[], $keys: number[] }): 
  Promise<{ result: { LineTotal?: number, InvoiceId?: number }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.invoiceIds)) {
      missingRequiredInParams.push('\'invoiceIds\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Invoices/datasources/ds_get_invoice_lines_grouped_by_invoiceId/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}

